import React, { useContext } from 'react';
import { ElementViewBuilderContext } from 'core/context';
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
import TableTextAction from '../TableTextAction';

const PaymentSummaryAction = ({ payment, children = payment?.id }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const paymentId = payment?.id;

	const handleOpenSummary = event => {
		event.stopPropagation();
		const elementViewKeys =
			ElementViewBuilderConfig.getAuthorizedElementViewKeys();

		setElementView({
			mode: 'stack',
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: paymentId,
			paycutId: payment?.paycut_id,
			isInvoice: false,
			drawerConfig: {
				maxWidth: '50vw',
				fullWidthBelow: '768px',
				noOverflow: true,
			},
			initialView: {
				tabKey: 'summaryKey',
				summaryOnly: true,
				readOnly: true,
				titleTab: `Resumen del pago #${paymentId}`,
				fechtData: {
					paymentId,
					paycutId: payment?.paycut_id,
					paid_to: payment?.paid_to,
					coinId: payment?.coin_id,
					coinSymbol: payment?.coin_symbol,
					summaryPerspective: 'payer',
				},
			},
		});
	};

	return (
		<TableTextAction
			type='button'
			onClick={handleOpenSummary}
			aria-label={`Abrir resumen del pago ${paymentId}`}
		>
			{children}
		</TableTextAction>
	);
};

export default PaymentSummaryAction;
